import { FORTA_BLUE } from '../../utils/colors';

import type { IconProps } from './types';

const DeleteIcon = (props: IconProps) => {
  const { color = FORTA_BLUE.primary } = props;

  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.00002 0.666504C13.6024 0.666504 17.3334 4.39746 17.3334 8.99984C17.3334 13.6022 13.6024 17.3332 9.00002 17.3332C4.39765 17.3332 0.666687 13.6022 0.666687 8.99984C0.666687 4.39746 4.39765 0.666504 9.00002 0.666504ZM12.3334 8.1665H5.66669C5.20645 8.1665 4.83335 8.53959 4.83335 8.99984C4.83335 9.46009 5.20645 9.83317 5.66669 9.83317H12.3334C12.7936 9.83317 13.1667 9.46009 13.1667 8.99984C13.1667 8.53959 12.7936 8.1665 12.3334 8.1665Z"
        fill={color}
      />
    </svg>
  );
};

export default DeleteIcon;
